import { BREAKPOINTS } from './consts';
import type { ImageSizesByDevice, TDevice } from './types';

/**
 * Получить строку для аттрибута src, согласно размерам
 * относительно типа устройства
 * @param sizesByDevice
 * @returns
 */
export function getSizesPicture(sizesByDevice: ImageSizesByDevice | null): string {
  const mediaByDevice = {
    mobile: `(max-width: ${BREAKPOINTS.TABLET - 1}px)`,
    tablet: `(min-width: ${BREAKPOINTS.TABLET}px)`,
    bigTablet: `(min-width: ${BREAKPOINTS.BIG_TABLET}px)`,
    desktop: `(min-width: ${BREAKPOINTS.DESKTOP}px)`,
  } as ImageSizesByDevice;

  const mediaByDeviceOrder = {
    mobile: 4,
    tablet: 3,
    bigTablet: 2,
    desktop: 1,
  } as Record<TDevice, number>;

  if (!sizesByDevice) {
    return '100vw';
  }

  const sizes = Object.keys(sizesByDevice)
    .sort((keyA, keyB) => mediaByDeviceOrder[keyA as TDevice] - mediaByDeviceOrder[keyB as TDevice])
    .map((key) => {
      const value = sizesByDevice[key as TDevice];
      return `${mediaByDevice[key as TDevice]} ${value}`;
    });

  sizes.push('100vw');

  return sizes.join(', ');
}
